import GenericWarning from './GenericWarning';

export default GenericWarning;
